import Lottie from "react-lottie";
import NoResults from "assets/lottie/no-results.json";

export function NoResultsIllustration(): JSX.Element {
  return (
      <Lottie
        style={{
          display: "grid",
          maxWidth: 300,
          maxHeight: 180
        }}
        options={{
          loop: true,
          autoplay: true,
          animationData: NoResults
        }}
      />
  );
}
